import { ShieldCheck, X } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { GARANTIA, RESSALVAS } from "@/lib/content";

const ListCard = ({ title, items, testid }) => (
  <div className="card-tech p-8" data-testid={testid}>
    <p className="eyebrow mb-4">{title}</p>
    <ul className="space-y-2 text-sm text-slate-300">
      {items.map((i) => <li key={i} className="flex gap-2"><X className="mt-0.5 h-4 w-4 shrink-0 text-red-500" />{i}</li>)}
    </ul>
  </div>
);

export default function Garantia() {
  return (
    <div data-testid="page-garantia">
      <PageHero eyebrow="Termo de garantia" title="Garantia de 90 dias">{GARANTIA.texto}</PageHero>
      <section className="mx-auto max-w-7xl space-y-6 px-4 py-16 sm:px-6">
        <div className="grid gap-6 md:grid-cols-[280px_1fr]">
          <div className="flex flex-col justify-center border border-red-800 bg-red-950/20 p-8">
            <ShieldCheck className="h-10 w-10 text-red-500" />
            <p className="mt-4 font-heading text-6xl font-bold text-white">90</p>
            <p className="font-mono text-xs uppercase tracking-wider text-slate-400">dias a partir do atendimento</p>
          </div>
          <div className="card-tech p-8" data-testid="garantia-condicoes">
            <p className="eyebrow mb-4">Condições</p>
            <ul className="space-y-3 text-slate-300">
              {GARANTIA.condicoes.map((c, i) => <li key={c} className="flex gap-3"><span className="font-mono text-red-500">0{i + 1}</span>{c}</li>)}
            </ul>
          </div>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          <ListCard title="Serviços não inclusos" items={RESSALVAS.nao_inclusos} testid="garantia-nao-inclusos" />
          <ListCard title="Não há responsabilidade sobre" items={RESSALVAS.nao_responsabilidade} testid="garantia-nao-responsabilidade" />
        </div>
        <p className="border-l-2 border-red-600 bg-[#111723] p-5 text-sm leading-relaxed text-slate-400">{RESSALVAS.observacao}</p>
      </section>
    </div>
  );
}
